import { IonBadge } from '@ionic/react'
import React, { HTMLAttributes } from 'react'
import { useSelector } from 'react-redux'
import { getRulesSelector } from '../../features/rules/selectors'
import { getErrorCount } from '../../utilities/runRulesValidation.util'
import { v4 as uuidv4 } from 'uuid'
import './ValidationBadge.component.css'

export interface IValidationBadge extends HTMLAttributes<HTMLIonBadgeElement> {
  color?: string
  action: string
}

const ValidationBadgeComponent: React.FC<IValidationBadge> = (props: IValidationBadge) => {
  const { color, action } = props
  const rulesState = useSelector(getRulesSelector)
  const { errors } = rulesState
  const errorCount = getErrorCount(errors, action)
  const testId = uuidv4()

  if (!errorCount) {
    return null
  }

  return (
    <IonBadge
      slot='end'
      data-testid={`ValidationBadgeCount${testId}`}
      color={color ? color : 'danger'}
      className='validation-badge'
      {...props}>
      {errorCount}
    </IonBadge>
  )
}

export default ValidationBadgeComponent
